module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("7iOmM"))).then(() => parcelRequire('8rm4T'));